export enum AssetType {
  Generic = 'Generic',
  CoverArt = 'CoverArt',
}
